import { Container } from 'unstated'
import Auth from '../auth'
import makeRequest from '../requests/base.request'

export default class UserContainer extends Container {

  state = {
    isLoggedIn: false,
    loadingProfile: true,
    profile: {},
    photo: {},
    menu: [],
    schools: [],
    selectedSchool: {},
    selectedGrade: {},
    segmentGrades: [],
    loadingSegmentGrades: true,
    classes: [],
    openModalCientAlertPoints: false,
    configurations: {
      nuAutomaticStudy: 2,
      inFrequencyAutomaticStudy: 1,
      nuDayOfWeekStartAutomaticStudy: 5,
      inCheckBlockWindow: false,
      inCheckContinueLater: true,
      inLimitStudentStudy: 0,
      nuStudentStudy: 2,
      inFrequencyStudentStudy: 1
    },
    periods: [],
    editPeriods: false,
    notifications: { amount: {} },
    redirectTo: null,
    isUserStudent:false,
    isUserTeacher:false,
    isUserCoordenador:false

  }


  setSchool = async (idSchool) => {
    // console.log('setSchool setSchool setSchool')
    await this.setState(() => {
      return { selectedSchool: idSchool };
    });
  };

  getCientAlertPoints = async () => {
    console.log(this.state.profile.idUser, localStorage.getItem(`cientAlertPoints_${this.state.profile.idUser}`));
    let open = localStorage.getItem(`cientAlertPoints_${this.state.profile.idUser}`) === 'true' ? true : false;
    console.log(open);
    this.setState({ openModalCientAlertPoints: open});
    return open;
  };

  setCientAlertPoints = () => {
    localStorage.setItem(`cientAlertPoints_${this.state.profile.idUser}`, true);
    this.setState({ openModalCientAlertPoints: true});
  }

  login = async () => {
    const session = Auth.restoreSession();
    if (session) {
     const validatarAtivacoes = await this.getQtdMaterialDidaticoAtivo();
      if(validatarAtivacoes !== undefined && validatarAtivacoes.ativacoes !== undefined && validatarAtivacoes.ativacoes >= 3){
        let redirectTo = null
        if (session.hash) {
          let path = session.hash.replace('#', '')
          if (path && path !== '/app') redirectTo = path
        }
        await this.setState({ isLoggedIn: true, redirectTo });
        return true;
      } else {
        await this.setState({ isLoggedIn: false });
        Auth.invalidateSession();
        window.location.href =  process.env.REACT_APP_EDU_URL;
        return true;
      }
    }
    Auth.authorize();
    return false;
  }

  logout = async () => {
    await this.setState({ isLoggedIn: false });
    Auth.invalidateSession()
  }

  getMenu = async () => {
    try {
      const menu = await makeRequest.get('menu')
      this.setState({ menu: menu })
    } catch (error) {
      console.error(error)
    }
  }

  async userProfile() {
    let role = this.state.profile.decodedToken.role
    if(role.includes('ev001')){
        this.setState({isUserStudent:true,isUserTeacher:false,isUserCoordenador:false})
        
    }
    if(role.includes('ev002')){
      this.setState({isUserStudent:false,isUserTeacher:true,isUserCoordenador:false})

       
    }
    if(role.includes('ev004') || role.includes('ev005')){
      this.setState({isUserStudent:false,isUserTeacher:false,isUserCoordenador:true})

    }
}

  fetchProfile = async () => {
    try {
      const profile = await makeRequest.get('perfil')
      if (profile) {
        profile.decodedToken = Auth.decodedToken();
        this.setState({ profile: profile, loadingProfile: false })
      }
      else {
        this.logout();
        return;
      }
    }
    catch (error) {
      console.error(error);
    }
  }

  getSchools = async () => {
    try {
      if(!this.state.schools || this.state.schools.length === 0 || !this.state.selectedSchool) {
        const schools = await makeRequest.get('escolas')
        // console.log(schools)
        await this.setState({ schools: schools, selectedSchool: schools[0], segmentGrades: [], classes: [] });
      }
    } catch (error) {
      console.error(error)
    }
  }

  getClasses = async (school, grade) => {
    try {
      const classes = await makeRequest.get(`turmas?school=${school}&grade=${grade}&year=${new Date().getFullYear()}`)
      //  console.log('clawess ', classes)
      await this.setState({ classes: classes || [] })
    } catch (error) {
      console.error(error)
    }
  }

  getSegmentGrades = async () => {
    try {
      const segmentGrades = await makeRequest.get('series-segmento')
      //  console.log('segment ', segmentGrades)
      await this.setState({ segmentGrades: segmentGrades || [], classes: [], loadingSegmentGrades: false })
    } catch (error) {
      console.error(error)
    }
  }

  hasGradeSelected = () => {
    return !(Object.keys(this.state.selectedGrade).length === 0);
  }

  getUserPhotoBySize = async (size) => {
    try {
      const userphoto = await makeRequest.get(`userphoto/${size}`)
      const photo = { ...this.state.photo };
      photo[size] = userphoto;
      this.setState({ photo })
    } catch (error) {
      console.error(error);
    }
  }

  getConfigurations = async () => {
    // console.log(this.state.selectedSchool)
    try {
      const response = await makeRequest.get(`configuracoes?school=${this.state.selectedSchool.idEntitySchool}&year=${new Date().getFullYear()}`)
      var configurations = response.configuracoes[0];
      // console.log('configurations', configurations)
      if (configurations) {
        await this.setState({
          configurations: { ...this.state.configurations, ...configurations }
        })
      }
    } catch (error) {
      console.error(error)
    }
  }

  getPeriods = async () => {
    try {
      const responseBody = await makeRequest.get(`periodos?school=${this.state.selectedSchool.idEntitySchool}`)
      // console.log(responseBody)
      if (responseBody.periodos && responseBody.periodos.length > 0) {
        await this.setState({
          periods: responseBody.periodos[0],
          editPeriods: false
        })
      }
    } catch (error) {
      console.error(error)
    }
  }

  getGestaoAcademica = async () => {
    try {
      const response = await makeRequest.get(`configuracoes/status/gestao-academica?school=${this.state.selectedSchool.idEntitySchool}`)
      //  console.log('gestao-academica', response)
      return response
    } catch (error) {
      console.error(error)
      return
    }
  }

  getGradeSchool = async () => {
    try {
      const response = await makeRequest.get(`configuracoes/series-escola?school=${this.state.selectedSchool.idEntitySchool}`)
      //  console.log('series-escola', response)
      return response
    } catch (error) {
      console.error(error)
      return
    }
  }

  fillPeriods = async () => {
    const ga = await this.getGestaoAcademica()
    // console.log(ga)
    if (ga) {
      if (ga === 'G') {
        await this.getPeriods()
      } else {
        const periodos = await this.getGradeSchool()
        // console.log('periodos', periodos)
        if (periodos && periodos.length > 0) {

          periodos[0] = periodos[0].map(p => {
            if (Object.keys(p.pe[0]).length === 0 && p.pe[0].constructor === Object) {
              // console.log('delete');
              delete p.pe;
            }
            return p
          })

          await this.setState({
            periods: periodos[0],
            editPeriods: true
          })
        }
      }
    }
  }

  getQtdNotifications = async () => {
    try {
      const qtd = await makeRequest.get('notificacoes/qtd')
      // console.log('qtd', qtd)
      let amount = {}

      let total = 0
      qtd.forEach(value => {
        for (var key in value) {
          total += value[key]
          amount[key] = value[key]
        }
      })
      amount.total = total
      this.setState({ notifications: { ...this.state.notifications, amount } })
    } catch (error) {
      console.error(error)
    }
  }

  saveConfigurations = async () => {
    try {
      // console.log('save config ', this.state.selectedSchool.idEntitySchool)
      const response = await makeRequest.post('configuracoes', { ...this.state.configurations, idSchool: this.state.selectedSchool.idEntitySchool })
      // console.log(response)
      return response
    } catch (error) {
      console.error(error)
    }
  }

  updatePeriods = async () => {
    try {
      const response = makeRequest.put('periodos/atualizar', { atualizarPeriodos: this.state.periods, idSchool: this.state.selectedSchool.idEntitySchool, year: new Date().getFullYear(), idAccount: this.state.profile.idAccount })
      // console.log(response)
      return response
    } catch (error) {
      console.error(error)
    }
  }

  getQtdMaterialDidaticoAtivo = async () => {
    try {
      const response =  await makeRequest.get(`consultar/material`);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}